<template>
  <div class="tab_container">
    <!-- 本月洞见/总结 -->
    <div class="hearder_title">
      <div class="flex_between">
        <img class="title_icon" src="@/assets/img/title-icon.svg" alt="dark" />
        本月洞见/总结
        <el-button
          size="mini"
          type="primary"
          class="title_btn"
          @click="handleSave('conclusion')"
          >保存</el-button
        >
      </div>
    </div>
    <conclusion ref="conclusion" />
    <!-- 主要竞争对手 -->
    <div class="hearder_title">
      <div class="flex_between">
        <img class="title_icon" src="@/assets/img/title-icon.svg" alt="dark" />
        主要竞争对手
        <el-button
          size="mini"
          type="primary"
          class="title_btn"
          @click="handleSave('competitor')"
          >保存</el-button
        >
      </div>
    </div>
    <competitor
      ref="competitor"
      @updateChannelCompetitor="updateChannelCompetitor"
    />
    <!-- 主要竞品及实销 -->
    <div class="hearder_title">
      <div class="flex_between">
        <img class="title_icon" src="@/assets/img/title-icon.svg" alt="dark" />
        主要竞品及实销
      </div>
    </div>
    <!-- 竞品产品及实销 -->
    <div class="second_title">
      竞品产品及实销
      <el-button
        size="mini"
        type="primary"
        class="title_btn"
        @click="handleSave('competitiveSales')"
        >保存</el-button
      >
    </div>
    <competitive-sales ref="competitiveSales" />
    <!-- 竞品产品价格及政策变化 -->
    <div class="second_title">
      竞品产品价格及政策变化
      <el-button
        size="mini"
        type="primary"
        class="title_btn"
        @click="handleSave('competitivePrice')"
        >保存</el-button
      >
    </div>
    <competitive-price ref="competitivePrice" />
    <!-- 竞品价格变化情况 -->
    <div class="third_title">
      竞品价格变化情况
      <el-button
        size="mini"
        type="primary"
        class="title_btn"
        @click="handleSave('competitivePriceChange')"
        >保存</el-button
      >
    </div>
    <competitive-price-change ref="competitivePriceChange" @setId="setId" />
    <!-- 竞品渠道模式及变化 -->
    <div class="hearder_title">
      <div class="flex_between">
        <img class="title_icon" src="@/assets/img/title-icon.svg" alt="dark" />
        竞品渠道模式及变化
        <el-button
          size="mini"
          type="primary"
          class="title_btn"
          @click="handleSave('competitiveChannels')"
          >保存</el-button
        >
      </div>
    </div>
    <competitive-channels
      ref="competitiveChannels"
      @updateChannelCompetitor="updateChannelCompetitor"
    />
    <!-- 竞品企业市场推广活动的变化 -->
    <div class="second_title">
      竞品企业市场推广活动的变化
      <el-button
        size="mini"
        type="primary"
        class="title_btn"
        @click="handleSave('competitiveActivityChange')"
        >保存</el-button
      >
    </div>
    <competitive-activity-change
      ref="competitiveActivityChange"
      @setId="setId"
    />
    <!-- 竞品企业舆情事件 -->
    <div class="second_title">
      竞品企业舆情事件
      <el-button
        size="mini"
        type="primary"
        class="title_btn"
        @click="handleSave('competitivePublicEvent')"
        >保存</el-button
      >
    </div>
    <competitive-public-event ref="competitivePublicEvent" @setId="setId" />
  </div>
</template>

<script>
import Conclusion from "./conclusion.vue";
import Competitor from "./competitor";
import CompetitiveSales from "./competitiveSales";
import CompetitivePrice from "./competitivePrice";
import CompetitivePriceChange from "./competitivePriceChange";
import competitiveChannels from "./competitiveChannels";
import CompetitiveActivityChange from "./competitiveActivityChange";
import CompetitivePublicEvent from "./competitivePublicEvent";
import { getLookCompeteApi } from "@/api/saleTaskCollection";

export default {
  components: {
    Conclusion,
    Competitor,
    CompetitiveSales,
    CompetitivePrice,
    CompetitivePriceChange,
    competitiveChannels,
    CompetitiveActivityChange,
    CompetitivePublicEvent
  },
  data() {
    return {};
  },
  methods: {
    async init(showDataObj) {
      await this.getLookCustomer(showDataObj.queryParams);
    },
    // 获取看竞争
    async getLookCustomer(queryParams = {}) {
      try {
        let data = {};
        const res = await getLookCompeteApi({
          ...queryParams
        });
        if (res.status == 0) {
          data = res.data || {};
        } else {
          this.$DonMessage.error(res.message);
        }
        this.$refs.conclusion.init(data.saleSummary, queryParams);
        this.$refs.competitor.init(
          data.saleCompetitionOpponentList,
          queryParams
        );
        this.$refs.competitiveSales.init(
          data.competitionProductsShixiaoLookList,
          queryParams
        );
        this.$refs.competitivePrice.init(
          data.competitionProductsPriceLookList,
          queryParams
        );
        this.$refs.competitivePriceChange.init(
          data.competitionChange,
          queryParams
        );
        this.$refs.competitiveChannels.init(
          data.saleCompetitionOpponentList,
          queryParams
        );
        this.$refs.competitiveActivityChange.init(
          data.competitionChange,
          queryParams
        );
        this.$refs.competitivePublicEvent.init(
          data.competitionChange,
          queryParams
        );
        this.$emit(
          "updateTime",
          "lookCompeteTabTime",
          this.getClosestDate([
            data.saleSummary?.updateTime,
            data.saleCompetitionOpponentList[0]?.updateTime,
            data.competitionProductsShixiaoLookList[0]?.updateTime,
            data.competitionProductsPriceLookList[0]?.updateTime,
            data.competitionChange?.updateTime
          ])
        );
      } catch (error) {}
    },
    // 获取最近的日期
    getClosestDate(dates) {
      if (dates.length === 0) return null; // 如果没有日期，返回null
      dates.sort((a, b) => a - b); // 按时间顺序排序
      return dates[0] || ""; // 取第一个元素，即最早的日期
    },
    // 保存
    handleSave(refField) {
      this.$refs[refField].handleSave(() => {
        this.$emit("updateTime");
      });
    },
    setId(id) {
      this.$refs.competitivePriceChange.form.id = id;
      this.$refs.competitiveActivityChange.form.id = id;
      this.$refs.competitivePublicEvent.form.id = id;
    },
    updateChannelCompetitor(data) {
      this.$refs.competitiveChannels.tableData = data;
      this.$refs.competitor.tableData = data;
    }
  }
};
</script>

<style lang="scss" scoped>
.tab_container {
  padding-bottom: 20px;
  .hearder_title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    color: #333333;
    padding: 14px 10px 14px 20px;
    border-bottom: 1px solid #dcdee0;
    .title_icon {
      margin-right: 10px;
    }
    p {
      font-size: 16px;
      color: #4095e5;
      font-weight: bold;
      i {
        font-size: 18px;
        color: #4095e5;
        display: inline-block;
        margin-right: 5px;
      }
    }
  }
  .second_title {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #1890ff;
    padding: 22px 10px 10px 62px;
    border-bottom: 1px solid #dcdee0;
  }
  .third_title {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #1890ff;
    padding: 10px 10px 10px 62px;
  }
  .second_title + .third_title {
    padding-top: 25px;
  }
  .title_btn {
    margin-left: 20px;
  }
}
</style>
